import { Navigate, type RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import PublicLayout from "../layout/PublicLayout";
import AdminLayout from "../layout/AdminLayout";
import Home from "../pages/home/page";
import Servicios from "../pages/servicios/page";
import Flota from "../pages/flota/page";
import Trabajos from "../pages/trabajos/page";
import Nosotros from "../pages/nosotros/page";
import Contacto from "../pages/contacto/page";
import SolicitarServicio from "../pages/solicitar-servicio/page";
import TrabajaConNosotros from "../pages/trabaja-con-nosotros/page";
import AdminGuard from "../pages/admin/components/AdminGuard";
import AdminLogin from "../pages/admin/login/page";
import AdminPanel from "../pages/admin/panel/page";
import AdminSolicitudes from "../pages/admin/solicitudes/page";
import AdminFlota from "../pages/admin/flota/page";
import AdminServicios from "../pages/admin/servicios/page";
import AdminHero from "../pages/admin/hero/page";
import AdminGaleria from "../pages/admin/galeria/page";
import AdminConfiguracion from "../pages/admin/configuracion/page";
import AdminUsuarios from "../pages/admin/usuarios/page";
import AdminAfiliados from "../pages/admin/afiliados/page";
import AuthCallback from "../pages/auth/callback/page";
import ResetPassword from "../pages/auth/reset-password/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <PublicLayout />,
    children: [
      { index: true, element: <Home /> },
      { path: "servicios", element: <Servicios /> },
      { path: "flota", element: <Flota /> },
      { path: "flota/:categoria", element: <Flota /> },
      { path: "trabajos", element: <Trabajos /> },
      { path: "nosotros", element: <Nosotros /> },
      { path: "contacto", element: <Contacto /> },
      { path: "solicitar-servicio", element: <SolicitarServicio /> },
      { path: "trabaja-con-nosotros", element: <TrabajaConNosotros /> },
      { path: "*", element: <NotFound /> },
    ],
  },
  { path: "/admin/login", element: <AdminLogin /> },
  {
    path: "/admin",
    element: <AdminGuard />,
    children: [
      {
        element: <AdminLayout />,
        children: [
          { index: true, element: <Navigate to="/admin/panel" replace /> },
          { path: "panel", element: <AdminPanel /> },
          { path: "solicitudes", element: <AdminSolicitudes /> },
          { path: "flota", element: <AdminFlota /> },
          { path: "servicios", element: <AdminServicios /> },
          { path: "hero", element: <AdminHero /> },
          { path: "galeria", element: <AdminGaleria /> },
          { path: "configuracion", element: <AdminConfiguracion /> },
          { path: "usuarios", element: <AdminUsuarios /> },
          { path: "afiliados", element: <AdminAfiliados /> },
          { path: "*", element: <Navigate to="/admin/panel" replace /> },
        ],
      },
    ],
  },
  { path: "/auth/callback", element: <AuthCallback /> },
  { path: "/auth/reset-password", element: <ResetPassword /> },
];

export default routes;